<template>
  <div>
    <vs-table :data="filteredList">
      <template slot="header">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="1" vs-lg="1" class="px-2">
            <AddEmails
              :clients="clients"
              :vendorId="vendorId"
              class="mt-4"
              @success="getEmails()"
            />
          </vs-col>

          <vs-col vs-xs="12" vs-sm="11" vs-lg="11" style="display: inline-flex">
            <div class="con-input-search vs-table--search">
              <input
                class="input-search vs-table--search-input mt-1"
                type="text"
                v-model="search"
              />
              <vs-icon icon="search"></vs-icon>
            </div>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <th>{{ $t('client') | capitalize }}</th>
        <th>{{ $t('emails') | capitalize }}</th>
        <th style="text-align: end">{{ $t('actions') | capitalize }}</th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ data[i].ClientName }}
          </vs-td>
          <vs-td>
            <!-- {{ data[i].other_emails }} -->
            <edit-column-input
              :value="data[i].other_emails"
              @update="updateEmails($event, data[i].id)"
              v-if="hasPermission(['IU VENDORS EDIT'])"
              inputPlaceholder="email1@tacna.net,email2@tacna.net"
            />
            <span v-else>
              {{ data[i].other_emails }}
            </span>
          </vs-td>
          <vs-td style="float: right">
            <action-icon
              icon="TrashIcon"
              :tooltip="$t('delete')"
              v-if="hasPermission(['IU VENDORS EDIT'])"
              @click="confirmDelete(data[i].id)"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import vSelect from 'vue-select'
import request from '../request'
import VendorAccountSidebar from './VendorAccountSidebar.vue'
import AddEmails from './AddEmails.vue'
import EditColumnInput from '@/views/components/table/EditColumnInput'
import loading from '@/mixins/Loading'

export default {
  props: ['vendorId'],
  mixins: [loading],
  components: {
    ActionIcon,
    EditColumnInput,
    'v-select': vSelect,
    VendorAccountSidebar,
    AddEmails,
  },
  data() {
    return {
      search:'',
      clients: [],
      emails: [],
      days: [],
      loading: {
        clients: false,
        emails: false,
        submit: false,
      },
      emailId: '',
    }
  },
  computed: {
    isLoading() {
      return this.loading.clients || this.loading.emails || this.loading.submit
    },
    filteredList() {
      return this.emails.filter(item => {
        return item.ClientName.toLowerCase().includes(this.search.toLowerCase()) ||  item.other_emails.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    getClients() {
      this.loading.clients = true
      request
        .getClients()
        .then((response) => {
          this.clients = response.data.clients
          this.loading.clients = false
        })
        .catch((response) => {
          this.loading.clients = false
          this.showValidationErrors(response)
        })
    },
    getEmails() {
      this.loading.emails = true
      request
        .getEmails(this.vendorId)
        .then((response) => {
          let res = [...response.data.emails]
          const emails = res.map((obj, i) => ({
            ...obj,
            other_emails: JSON.parse(res[i].other_emails).toString(),
          }))
          this.emails = [...emails]
          this.loading.emails = false
        })
        .catch((response) => {
          this.loading.emails = false
          this.showValidationErrors(response)
        })
    },
    updateEmails(value, id) {
      let emails = value.split(',')
      if (!this.validateEmail(emails)) {
        this.$vs.notify({
          color: 'warning',
          title: 'Error',
          text: 'Invalid email',
        })
        return
      }
      const payload = {
        emails: emails,
      }
      this.loading.submit = true
      request
        .updateEmails(id, payload)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Emails Updated',
          })
          this.getEmails()
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
        })
    },
    validateEmail(emails) {
      const reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let result = true
      emails.forEach((email) => {
        if (reg.test(email) == false) {
          result = false
        }
      })
      return result
    },
    confirmDelete(id) {
      this.emailId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteEmails,
      })
    },
    deleteEmails() {
      this.loading.submit = true
      request
        .deleteEmails(this.emailId)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Emails Deleted',
          })
          this.getEmails()
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
        })
    },
  },
  mounted() {
    this.getClients()
    this.getEmails()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('vendor-details-loading')
      } else {
        this.closeLoading('vendor-details-loading')
      }
    },
  },
}
</script>

<style>
.vs-table--not-data {
  display: none !important;
}
</style>